import React, { useState, useEffect } from 'react';
import { Card, Form, Input, Button, Select, message, Spin, Alert } from 'antd';
import { useNavigate } from 'react-router-dom';
import { schoolAPI, classAPI } from '../../services/api';
import { useAuth } from '../../contexts/AuthContext';
import { normalizeScopeId, resolveDefaultSchoolId, shouldLockSchoolSelection } from '../../utils/schoolScope';

const { Option } = Select;

const ClassCreate = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [schools, setSchools] = useState([]);
  const { user } = useAuth();
  
  useEffect(() => {
    if (user) fetchSchools();
  }, [user]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchSchools = async () => {
    try {
      setLoading(true);
      const response = await schoolAPI.getAll();
      const rows = response.data.data || [];
      const availableSchools = user?.workbenchSchoolId ? rows.filter(s => String(s.id) === user.workbenchSchoolId) : rows;
      setSchools(availableSchools);
      const defaultSchoolId = resolveDefaultSchoolId(user, availableSchools);
      if (defaultSchoolId) form.setFieldsValue({ schoolId: defaultSchoolId });
      setError(null);
    } catch (err) {
      console.error('获取学校列表失败:', err);
      setError('获取学校列表失败，请检查网络连接或重新登录');
    } finally {
      setLoading(false);
    }
  };

  // 表单提交
  const onFinish = async (values) => {
    try {
      setSubmitting(true);
      
      const response = await classAPI.create(values);
      
      message.success('班级创建成功');
      
      // 显示班级口令
      if (response.data?.data?.token) {
        message.info(`班级登录口令: ${response.data.data.token}`);
      }
      
      // 返回列表页
      navigate('/classes');
    } catch (err) {
      console.error('创建班级失败:', err);
      setError('创建班级失败: ' + (err.response?.data?.message || err.message));
      setSubmitting(false);
    }
  };

  return (
    <Card title="添加班级">
      <Spin spinning={loading}>
        {error && <Alert message={error} type="error" showIcon style={{ marginBottom: 16 }} />}
        
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
        >
          <Form.Item
            name="name"
            label="班级名称"
            rules={[{ required: true, message: '请输入班级名称' }]}
          >
            <Input placeholder="请输入班级名称" />
          </Form.Item>
          
          <Form.Item
            name="grade"
            label="年级"
          >
            <Input placeholder="请输入年级" />
          </Form.Item>
          
          <Form.Item
            name="schoolId"
            label="所属学校"
            rules={[{ required: true, message: '请选择所属学校' }]}
          >
            <Select
              placeholder="请选择所属学校"
              disabled={shouldLockSchoolSelection(user, schools)}
              showSearch
              optionFilterProp="children"
            >
              {schools.map(school => (
                <Option key={school.id} value={normalizeScopeId(school.id)}>{school.name}</Option>
              ))}
            </Select>
          </Form.Item>
          
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={submitting}>
              创建班级
            </Button>
            <Button style={{ marginLeft: 8 }} onClick={() => navigate('/classes')}>
              取消
            </Button>
          </Form.Item>
        </Form>
      </Spin>
    </Card>
  );
};

export default ClassCreate; 
